export default "__VITE_ASSET__1f90ca0e__"